import { useAppSelector } from "../../../../../stateManagement/hooks/redux"
import { shortMeasureTypesNames } from "../../../../diagnostics/diagnosticsPathNormativitiesSection"

const admissibleIconSrc = require('../../../../../assets/images/fontAwesomeIcons/check-circle-regular.svg').default
const inadmissibleIconSrc = require('../../../../../assets/images/fontAwesomeIcons/circle-xmark-regular.svg').default

// PathNormativitiesMeasureTypesGroup
export default function PNMTGContent() {

    const diagnosticsPathNormativities = useAppSelector(state => state.diagnosticsPathNormativities)
    const { pathNormativitiesMapMultipleMeasureTypes: activeMeasureTypes, pathNormativitiesMapNormativityFlag: normativityFlag } = diagnosticsPathNormativities ?? {}

    return (
        <>
            {Object.keys(activeMeasureTypes).map((measureType: any) => {
                if (activeMeasureTypes[measureType]) {
                    return (
                        <div className="tooltip-info-row normativity-segment">
                            <span>{shortMeasureTypesNames[measureType]}: </span>
                            <img src={normativityFlag ? admissibleIconSrc : inadmissibleIconSrc} />
                            <span>{normativityFlag ? 'В нормативе' : 'Не в нормативе'}</span>
                        </div>
                    )
                }
            })}
        </>
    )
}
